// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Dropdown, InputText } from 'ui_kit_qmd'
import './GeneralInfoEdit.scss'
import {
  HEIGHT_FT_OPTIONS,
  HEIGHT_IN_OPTIONS,
  MARITAL_STATUS_OPTIONS,
  RACIAL_BACKGROUND_OPTIONS,
  text,
} from './Constants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../../../utils/errormessages'
import { HEIGHT_TEXT, WEIGHT_TEXT } from '../../../../../utils/constants'

const validateWeightValue = /^[0-9]*$/

export const GeneralInfoEdit = forwardRef(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ identity, height, weight, generalInfo, isNewPatientAgeValueLessThen18, patientInfo }, ref) => {
    const [heightFtValue, setHeightFtValue] = useState('')
    const [heightInValue, setHeightInValue] = useState('')
    const [heightFtError, setHeightFtError] = useState('')
    const [weightValue, setWeightValue] = useState('')
    const [weightError, setWeightError] = useState('')
    const [maritalValue, setMaritalValue] = useState()
    const [racialValue, setRacialValue] = useState('')
    const [genderIdentityValue, setGenderIdentityValue] = useState('')
    const dropdownContainerStyle = {
      width: '100%',
    }

    const dropdownHeight = {
      height: 145,
    }

    useEffect(() => {
      if (generalInfo) {
        const { heightFt, heightIn, WeightPounds, MaritalStatus, GenderIdentity, RacialBackground, isError } =
          generalInfo
        setHeightFtValue(heightFt)
        setHeightInValue(heightIn)
        setWeightValue(WeightPounds ? `${WeightPounds}` : '')
        setMaritalValue(MaritalStatus || '')
        setRacialValue(RacialBackground || '')
        setGenderIdentityValue(GenderIdentity || '')
        if (isError) {
          if (isNewPatientAgeValueLessThen18 && typeof isError === 'boolean') {
            if (!heightFt) {
              setHeightFtError(
                // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                getUserFriendlyErrorMessage(errorCodes.HEIGHT_WEIGHT_IS_REQUIRED_FIELD, null, HEIGHT_TEXT),
              )
            }
            if (!WeightPounds) {
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              setWeightError(getUserFriendlyErrorMessage(errorCodes.HEIGHT_WEIGHT_IS_REQUIRED_FIELD, null, WEIGHT_TEXT))
            }
          } else {
            setHeightFtError(isError)
          }
        }
      } else {
        setHeightFtValue(height ? `${Math.floor(height / 12)}` : '')
        setHeightInValue(height ? `${height % 12}` : '')
        setWeightValue(weight ? `${weight}` : '')
        setMaritalValue(identity[0].value === '--' ? '' : identity[0].value)
        setRacialValue(identity[3].value === '--' ? '' : identity[3].value)
        setGenderIdentityValue(identity[2].value === '--' ? '' : identity[2].value)
      }
    }, [])

    useEffect(() => {
      if (generalInfo) {
        const { heightFt, WeightPounds, isError } = generalInfo

        if (isError) {
          if (isNewPatientAgeValueLessThen18 && typeof isError === 'boolean') {
            if (!heightFt) {
              setHeightFtError(
                // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                getUserFriendlyErrorMessage(errorCodes.HEIGHT_WEIGHT_IS_REQUIRED_FIELD, null, HEIGHT_TEXT),
              )
            }
            if (!WeightPounds) {
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              setWeightError(getUserFriendlyErrorMessage(errorCodes.HEIGHT_WEIGHT_IS_REQUIRED_FIELD, null, WEIGHT_TEXT))
            }
          }
        }
      }
    }, [generalInfo])

    useEffect(() => {
      if (isNewPatientAgeValueLessThen18) {
        if (!height) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setHeightFtError(getUserFriendlyErrorMessage(errorCodes.HEIGHT_WEIGHT_IS_REQUIRED_FIELD, null, HEIGHT_TEXT))
        }
        if (!weight) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setWeightError(getUserFriendlyErrorMessage(errorCodes.HEIGHT_WEIGHT_IS_REQUIRED_FIELD, null, WEIGHT_TEXT))
        }
      }
    }, [isNewPatientAgeValueLessThen18])

    useImperativeHandle(ref, () => ({
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      checkSave: (isNewPatientAgeValueLessThen18Value) => {
        if (isNewPatientAgeValueLessThen18Value && (!heightFtValue || !weightValue)) {
          return { isError: true }
        }
        if (heightInValue && !heightFtValue) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          const isError = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.HEIGHT_FT_LOWER)
          setHeightFtError(isError)
          return { isError }
        }
        return {
          HeightInches: heightFtValue ? Number(heightFtValue) * 12 + Number(heightInValue || '0') : null,
          WeightPounds: Number(weightValue) || null,
          MaritalStatus: maritalValue !== null && maritalValue !== '' ? maritalValue : null,
          GenderIdentity: genderIdentityValue.trim() ? genderIdentityValue.trim() : null,
          RacialBackground: racialValue !== null && racialValue !== '' ? racialValue : null,
        }
      },
      getInfo: () => ({
        HeightInches:
          heightFtValue ? Number(heightFtValue || '0') * 12 + Number(heightInValue || '0')
          : heightInValue ? Number(heightInValue || '0')
          : null,
        heightIn: heightInValue,
        heightFt: heightFtValue,
        WeightPounds: Number(weightValue) || null,
        MaritalStatus: maritalValue !== null && maritalValue !== '' ? maritalValue : null,
        GenderIdentity: genderIdentityValue.trim() ? genderIdentityValue.trim() : null,
        RacialBackground: racialValue !== null && racialValue !== '' ? racialValue : null,
        isError: heightFtError,
      }),
    }))
    function onWeightBlur() {
      if (
        Number(weightValue) > 900 ||
        Number(weightValue) < 1 ||
        weightValue === '' ||
        !validateWeightValue.exec(weightValue)
      ) {
        setWeightValue(weight || '')
      } else {
        setWeightValue(weightValue.toString().replace(/^0+/, ''))
      }
    }
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSetHeightFt = (value) => {
      setHeightFtValue(value)
      setHeightFtError('')
    }

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSetHeightIn = (value) => {
      setHeightInValue(value)
    }

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSetWeightValue = (value) => {
      if (validateWeightValue.test(value)) {
        setWeightError('')
        setWeightValue(value)
      }
    }

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    function getEditView(title) {
      return (
        <div className='general-info-edit-card-container'>
          <div className='general-info-edit-title-container'>
            <label className='general-info-edit-card-full-name bold'>{`${title}`}</label>
          </div>
          {title === text.IDENTITY ?
            <div className='general-info-edit-identity-container'>
              <Dropdown
                dropId='patient-card-marital'
                isStateDropdown
                options={MARITAL_STATUS_OPTIONS}
                containerStyle={dropdownContainerStyle}
                dropdownContainerStyle={dropdownHeight}
                label={text.MARITAL_STATUS}
                setValue={setMaritalValue}
                value={maritalValue}
              />
              <InputText
                label={text.SEX_AT_BIRTH}
                containerStyle={{ marginTop: 44, width: '100%' }}
                value={identity[1].value}
                localError={false}
                view='visitType'
                disabled
              />
              <InputText
                required
                label={text.GENDER_IDENTITY}
                maxLength={50}
                containerStyle={{ marginTop: 44, width: '100%', marginBottom: 44 }}
                value={genderIdentityValue}
                localError={false}
                view='visitType'
                setValue={setGenderIdentityValue}
              />
              <Dropdown
                dropId='patient-card-racial'
                isStateDropdown
                options={RACIAL_BACKGROUND_OPTIONS}
                containerStyle={dropdownContainerStyle}
                dropdownContainerStyle={dropdownHeight}
                label={text.RACIAL_BACKGROUND}
                setValue={setRacialValue}
                value={racialValue}
                showAbove
              />
            </div>
          : <>
              <div className='general-info-edit-dropdown-container'>
                <div className='general-info-edit-dropdown-row' style={{ marginRight: 8 }}>
                  <Dropdown
                    dropId='patient-card-ft'
                    isStateDropdown
                    options={HEIGHT_FT_OPTIONS}
                    containerStyle={dropdownContainerStyle}
                    dropdownContainerStyle={dropdownHeight}
                    label={text.HEIGHT_FT}
                    setValue={onSetHeightFt}
                    isError={heightFtError}
                    value={heightFtValue}
                  />
                </div>
                <div className='general-info-edit-dropdown-row' style={{ marginLeft: 0 }}>
                  <Dropdown
                    dropId='patient-card-in'
                    isStateDropdown
                    options={HEIGHT_IN_OPTIONS}
                    containerStyle={dropdownContainerStyle}
                    dropdownContainerStyle={dropdownHeight}
                    label={text.HEIGHT_IN}
                    setValue={onSetHeightIn}
                    value={heightInValue}
                  />
                </div>
              </div>
              {heightFtError ?
                <label className='input-text-local-error-label general-info-height-ft-local-error'>
                  {heightFtError}
                </label>
              : null}
              <InputText
                required
                label={text.WEIGHT_TEXT}
                containerStyle={{ marginTop: 44, width: '100%' }}
                value={weightValue}
                // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                onUserBlur={(e) => {
                  // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
                  onWeightBlur(e)
                }}
                type='wholeNumber'
                view='visitType'
                setValue={onSetWeightValue}
                isError={weightError}
                localError={weightError}
              />
            </>
          }
        </div>
      )
    }

    return (
      <>
        {getEditView(text.BODY_MEASUREMENTS)}
        {getEditView(text.IDENTITY)}
      </>
    )
  },
)
